<template>

<div class='row' v-if='isReady'>

    <div class="col-12 add-links">
        <div class="row pt-2 pb-1">
            <div class='col-12 col-md-5 pr-md-0 mb-1'>
                <input v-model.trim='model.title' class='form-control' placeholder="Име за линка">
            </div>
            <div class='col-12 col-md-5 pr-md-0 mb-1'>
                <input v-model.trim='model.url' class='form-control' placeholder="URL адрес">
            </div>
            <div class='col-12 col-md-2'>
                <button @click='addLink' class='btn btn-secondary btn-block'>Добави</button>
            </div>
        </div>
    </div>

    <div class="col-12">
        <hr>
    </div>

    <div class="col-12 added-links">
        
        <div class='row pt-2 pb-2' v-for='(l,i) in links'>
            
            <div class="col-12">
                <small>Линк #{{ i+1 }}</small>
            </div>
            <div class='col-12 col-md-5 pr-md-0 mb-1'>
                <input v-model.trim='l.title' class='form-control' @change='refreshParent'>
            </div>
            <div class='col-12 col-md-5 pr-md-0 mb-1'>
                <input v-model.trim='l.url' class='form-control' @change='refreshParent'>
            </div>
            <div class='col-12 col-md-2'>
                <button @click='removeLink(l,i)' class='btn btn-danger btn-block'>
                    <span class="icon icon-x"></span>
                </button>
            </div>

        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( this.$parent.model != null && typeof this.$parent.model == 'object' ) {

                var links = this.$parent.model.links;

                this.model = Object.assign({}, this.mdl);

                if( !links ) {
                   
                    this.links = [];
               
                } else {

                    if( typeof links == 'object' ) {
                        this.links = links;
                    } else {
                        this.links = JSON.parse( links );
                    }

                }

                this.isReady = true;
            }

        },

        data() {
            return {
                isReady : false,
                links   : false,
                model   : false,

                mdl : {
                    title : '',
                    url   : ''
                }

            }
        },

        methods : {
            
            addLink() {
                this.links.push( Object.assign({},this.model) );
                this.model = Object.assign({}, this.mdl);

                this.refreshParent();
            },

            removeLink( l, i ) {
                this.links.splice( i, 1 );
                this.refreshParent();
            },

            refreshParent() {
                this.$parent.model.links = JSON.stringify( this.links );
            }

        }

    }
</script>
